import { Box, Button, Dialog, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useResetIntegrationStatusesMutation } from "../../features/user/userApiSlice";

export const EmailBlockedDialog = ({ onClose, open }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [resetIntegrations, { isLoading: isResetLoading }] =
		useResetIntegrationStatusesMutation();

	const handleResetIntegrations = async () => {
		await resetIntegrations()
			.unwrap()
			.then(() => {
				enqueueSnackbar(t("restarted_integration_status"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([_key, message]) => {
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			})
			.finally(() => {
				onClose();
			});
	};

	return (
		<Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
			<Box sx={{ padding: "30px" }}>
				<Typography
					variant="h4"
					component="h2"
					sx={{ textAlign: "center", mb: "10px" }}
				>
					{t("integration_error")}
				</Typography>
				<Typography
					variant="p"
					component="h2"
					sx={{ textAlign: "center", mb: "10px", fontWeight: 500 }}
				>
					{t("integration_error_description")}
				</Typography>
				<Box
					sx={{ display: "flex", justifyContent: "space-around", mt: "20px" }}
				>
					<Link to="/integrations">
						<Button variant="contained" onClick={onClose}>
							{t("redirect_to_integration_settings")}
						</Button>
					</Link>
					<Button
						loading={isResetLoading}
						variant="contained"
						color="error"
						disabled={isResetLoading}
						onClick={handleResetIntegrations}
					>
						{t("ignore")}
					</Button>
				</Box>
			</Box>
		</Dialog>
	);
};
